import React, { lazy } from "react";
import styled from "styled-components";

import Slider from "react-slick";
import "../../../node_modules/slick-carousel/slick/slick.css";
import "../../../node_modules/slick-carousel/slick/slick-theme.css";

const Card = lazy(() => import("../../components/Card/index"));

const Section = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 5rem 0;
`;

const Title = styled.h1`
  color: #0a0b10;
  display: inline-block;
  font-size: calc(1rem + 1.5vw);
  margin-top: 1.5rem;
  position: relative;
  &::before {
    content: "";
    height: 1px;
    width: 50%;
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translate(-50%, 0.5rem);
    /* or 100px */
    border-bottom: 2px solid var(--purple);
  }
`;

const Carousal = styled.div`
  width: 50vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media only Screen and (max-width: 40em) {
    width: 90vw;
    .slick-slider .slick-arrow {
      display: none;
    }
  }
  .slick-slider .slick-arrow:before {
    color: #0a0b10;
    font-size: 1.5rem;
    @media only Screen and (max-width: 40em) {
      display: none;
    }
  }
  .slick-slider .slick-dots button:before {
    color: #0a0b10;
    font-size: 1.5rem;
  }
  .slick-slide.slick-active {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin: 0;
    padding: 0;
    margin-bottom: 3rem;
  }
`;

const Testimonials = () => {
  const settings = {
    dots: true,
    infinite: true,

    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <Section>
      <Title>Quelques commentaires sur nous !</Title>
      <Carousal>
        <Slider {...settings}>
          <Card
            text="Nous avons fait appel à AZ Digital pour la création de notre site e-commerce. Le site est moderne, 
            fluide et parfaitement adapté à nos besoins. Grâce à leur travail, 
            notre boutique en ligne inspire confiance et offre une excellente expérience client."
            name="PinsTesCrocs"
            image="avatar-1"
          />

          <Card
            text="Nous avons confié à cette agence la création d’un filtre Snapchat, du logo de notre marque ainsi que de nos cartes de visite, 
            et le résultat est vraiment au rendez-vous. L’équipe a été créative, professionnelle et très à l’écoute de nos besoins. 
            Le logo reflète parfaitement notre identité, le filtre Snapchat a beaucoup plu à notre communauté, 
            et les cartes de visite ont un rendu moderne et qualitatif."
            name="MaDzDress"
            image="avatar-2"
          />

          <Card
            text="AZ Digital nous a aidés à mettre en place une plaque NFC pour récolter plus facilement nos avis Google.
            La solution est simple à utiliser, propre visuellement et très pratique au quotidien."
            name="Avis Google NFC"
            image="avatar-3"
          />

          <Card
            text="Nous avions besoin d’un support clair et professionnel pour présenter nos services.
            Les flyers et cartes de visite livrés par AZ Digital donnent une image beaucoup plus sérieuse à notre activité."
            name="Communication locale"
            image="avatar-4"
          />
        </Slider>
      </Carousal>
    </Section>
  );
};

export default Testimonials;
